import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import StoresDropdown from '../StoresDropdown';

import LINKS from 'constants/links';

const BUTTONS_NAV = [
  {
    name: placeholder('actions.seeCouponsByStore'),
    link: LINKS.COUPONS,
    testSelector: 'store-coupon-tab',
    onClick: (_, gaEventCategory) =>
      sendEvent({
        action: 'topbar_store_coupons',
        category: gaEventCategory,
      }),
  },
  {
    name: placeholder('actions.seePromobitCoupons'),
    link: LINKS.PROMOBIT_COUPONS,
    testSelector: 'promobit-coupons-tab',
    onClick: (_, gaEventCategory) =>
      sendEvent({
        action: 'topbar_promobit_coupons',
        category: gaEventCategory,
      }),
  },
];

const CouponsNavigation = ({ gaEventCategory }) => (
  <>
    <StoresDropdown gaEventCategory={gaEventCategory} />
    {BUTTONS_NAV.map(({ name, link, testSelector, onClick }) => (
      <NextLink key={name} href={link} prefetch={false} passHref>
        <Button
          as="a"
          className="mr-2"
          data-test-selector={testSelector}
          size="size4"
          type="neutral-ghost"
          onClick={(e) => {
            onClick(e, gaEventCategory);
          }}
        >
          {name}
        </Button>
      </NextLink>
    ))}
  </>
);

CouponsNavigation.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default CouponsNavigation;
